import React, { PureComponent } from 'react'
import { TextArea, Form, Grid, Checkbox, Icon, Menu, Label, Dimmer, Loader, Button, Modal } from 'semantic-ui-react'
import firebase from 'firebase/app'
import map from 'lodash/map'

import ModalRefund from './ModalRefund'

import utils from '../../utils'

class ModalCancel extends PureComponent {
  constructor(props) {
    super(props)

    this.state = {
      loading: true,
      cancelling: false,
      reasons: {},
      selectedReason: null,
      blackListChecked: false,
      blackListReason: '',

      showRefundModal: false,
    }
  }

  componentDidMount() {
    this.orderReasonSubscriber = firebase.database().ref('reasons/order')

    this.orderReasonSubscriber.on('value', snapshot => {
      const reasons = snapshot.val()

      this.setState({
        loading: false,
        reasons,
      })
    })
  }

  componentWillUnmount() {
    if (this.orderReasonSubscriber) {
      this.orderReasonSubscriber.off()
    }
  }

  cancelOrder = async () => {
    try {
      const { order } = this.props
      const { reasons, selectedReason, blackListChecked, blackListReason } = this.state

      const orderUid = order.key
      const branchUid = order.restaurant.branch.key
      const driverUid = order.deliverer
      const customerUid = order.deliveree
      const { forceCancel } = order

      const cancelDescription = (selectedReason && reasons[selectedReason].text) || 'No Reason'
      const cancelKeyCode = (selectedReason && reasons[selectedReason].key_code) || 'DEFAULT'

      const params = {
        orderUid,
        branchUid,
        driverUid,
        customerUid,
        forceCancel,
        cancelDescription,
        cancelKeyCode,
        blacklist: blackListChecked ? blackListReason : null,
      }

      this.setState({ cancelling: true, showRefundModal: false })

      const functions = firebase
        .app()
        .functions('asia-northeast1')
        .httpsCallable('orderAction')

      await functions({ actionType: 'cancel', ...params })

      this.setState({ cancelling: false }, this.onCloseClick)
    } catch (error) {
      alert(error.message || error)
      this.setState({ cancelling: false })
    }
  }

  onToggleCheck = () => {
    const { blackListChecked } = this.state

    this.setState({ blackListChecked: !blackListChecked })
  }

  onCancelClick = () => {
    const { blackListChecked, blackListReason } = this.state
    const { order } = this.props

    if (blackListChecked && blackListReason.length === 0) {
      return alert('Please input blacklist reason')
    }

    const orderNumber = utils.order.getOrderNumber(order)

    const confirmation = window.confirm(`Are you sure you want to cancel the order ${orderNumber} ?`)

    if (confirmation) {
      if (order.payment_gateway) {
        this.setState({ showRefundModal: true })
      } else {
        return this.cancelOrder()
      }

    }

    return false
  }

  onCloseClick = () => {
    const { onCancel } = this.props

    this.setState({ selectedReason: null, blackListChecked: false, blackListReason: '' }, onCancel)
  }

  renderDefault = () => {
    const { selectedReason } = this.state

    return (
      <Menu.Item
        active={selectedReason === null}
        onClick={() => this.setState({ selectedReason: null })}
        style={{ padding: '13px 10px', borderRadius: 0 }}
      >
        <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center' }}>
          <Label style={{ marginRight: 10 }}>DEFAULT</Label>
          <div style={{ display: 'flex', flex: 1 }}>No Reason</div>
          {selectedReason === null && (
            <div style={{ display: 'flex', justifyContent: 'center', width: 20, marginLeft: 5 }}>
              <Icon name="check" color="green" />
            </div>
          )}
        </div>
      </Menu.Item>
    )
  }

  renderReasonRow = (reason, reasonKey) => {
    const { selectedReason } = this.state

    return (
      <Menu.Item
        key={reason.key_code}
        active={selectedReason === reasonKey}
        onClick={() => this.setState({ selectedReason: reasonKey })}
        style={{ padding: '13px 10px', borderRadius: 0 }}
      >
        <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center' }}>
          <Label style={{ marginRight: 10 }}>{reason.key_code}</Label>
          <div style={{ display: 'flex', flex: 1 }}>{reason.text}</div>
          {selectedReason === reasonKey && (
            <div style={{ display: 'flex', justifyContent: 'center', width: 20, marginLeft: 5 }}>
              <Icon name="check" color="green" />
            </div>
          )}
        </div>
      </Menu.Item>
    )
  }

  renderReasons = () => {
    const { reasons } = this.state

    return (
      <Menu
        fluid
        vertical
        style={{
          maxHeight: 'calc(50vh - 20px)',
          overflow: 'auto',
        }}
      >
        {this.renderDefault()}
        {map(reasons, (reason, reasonKey) => this.renderReasonRow(reason, reasonKey))}
      </Menu>
    )
  }

  renderLoading = () => {
    return (
      <Dimmer active inverted>
        <Loader inverted />
      </Dimmer>
    )
  }

  render() {
    const { visible, order, saveRefundTo } = this.props
    const { cancelling, blackListChecked, blackListReason, loading, showRefundModal } = this.state

    const mergedOrderId = (order && utils.order.getOrderNumber(order)) || '#######'

    return (
      <Modal
        open={visible}
        style={{ marginTop: 0, width: 600 }}
        closeOnEscape={!cancelling}
        closeOnDimmerClick={!cancelling}
        onClose={this.onCloseClick}
      >
        <Modal.Header>
          <div style={{ display: 'flex', flexDirection: 'row' }}>
            <div style={{ display: 'flex', flex: 1 }}>Why you cancel this order?</div>
            <div style={{ display: 'flex' }}>{mergedOrderId}</div>
          </div>
        </Modal.Header>
        <Modal.Content style={{ padding: 0 }}>
          <Grid columns="equal" style={{ margin: 0 }}>
            <Grid.Row style={{ padding: 0 }}>
              <Grid.Column style={{ padding: 10 }}>{loading ? this.renderLoading() : this.renderReasons()}</Grid.Column>
            </Grid.Row>
          </Grid>
        </Modal.Content>
        <Modal.Actions style={{ position: 'relative' }}>
          <div style={{ display: 'flex', flexDirection: 'row' }}>
            <div style={{ display: 'flex', flex: 1, flexDirection: 'column', alignItems: 'flex-start', justifyContent: 'flex-start' }}>
              <React.Fragment>
                <Checkbox label="Blacklist" checked={blackListChecked} onChange={this.onToggleCheck} />
              </React.Fragment>

              <div style={{ width: '100%', marginTop: 10 }}>
                {blackListChecked && (
                  <Form>
                    <TextArea
                      placeholder="Blacklist reason..."
                      style={{ minHeight: 60, maxHeight: 150 }}
                      onChange={e => this.setState({ blackListReason: e.target.value })}
                      value={blackListReason}
                    />
                  </Form>
                )}
              </div>
            </div>

            <div style={{ display: 'flex', flex: 1, flexDirection: 'row', alignItems: 'flex-end', justifyContent: 'flex-end' }}>
              <Button onClick={this.onCloseClick} negative disabled={cancelling}>
                Close
              </Button>
              <Button loading={cancelling} disabled={cancelling} onClick={this.onCancelClick} secondary content="Cancel Order" />
            </div>
          </div>
        </Modal.Actions>


        {
          showRefundModal &&
            <ModalRefund
              order={order}
              visible={showRefundModal}
              onSave={saveRefundTo}
              onSaveSuccess={this.cancelOrder}
            />
        }
      </Modal>
    )
  }
}

export default ModalCancel



// WEBPACK FOOTER //
// ./src/components/orders/ModalCancelReasons.js